/*
 * @Author: keman.chen
 * @Date: 2023-08-25 11:35:51
 * @LastEditTime: 2024-01-09 12:09:55
 * @LastEditors: keman.chen
 * @Description: 自定义上报
 * @FilePath: /tlog-dashboard/Users/keman.chen/code/monitor/packages/core/src/external.ts
 */
import { BREADCRUMBTYPES, EVENTTYPES } from '@tr-infra/pilot-shared'
import {
  isError,
  extractErrorStack,
  getLocationHref,
  getTimestamp,
  unknownToString,
  isWxMiniEnv,
  Severity,
  getCurrentRoute
} from '@tr-infra/pilot-utils'
import { transportData } from './transportData'
import { breadcrumb } from './breadcrumb'
import { TNumStrObj } from '@tr-infra/pilot-types'

interface LogTypes {
  message: TNumStrObj
  tag?: TNumStrObj
  level?: Severity
  error?: Error | any
  type?: string,
  attributes?: any
}

/**
 *
 * 自定义上报事件
 * @export
 * @param {LogTypes} { message = 'emptyMsg', tag = '', level = Severity.Critical, ex = '' }
 */
export function log({ message = 'empty message', tag = '', level = Severity.Info, error = '', attributes = {} }: LogTypes): void {
  let errorInfo = {}
  if (isError(error)) {
    errorInfo = extractErrorStack(error, level)
  }
  const info = {
    type: EVENTTYPES.CUSTOM,
    level: Severity.fromString(level.toLocaleLowerCase()),
    message: unknownToString(message),
    name: 'Pilot.log',
    customTag: unknownToString(tag),
    time: getTimestamp(),
    url: isWxMiniEnv ? getCurrentRoute() : getLocationHref(),
    errorInfo,
    ...attributes
  }
  breadcrumb.push({
    type: BREADCRUMBTYPES.CUSTOMER,
    category: breadcrumb.getCategory(BREADCRUMBTYPES.CUSTOMER),
    data: message,
    level: Severity.fromString(level.toLocaleLowerCase())
  })
  transportData.send(info);
}
